import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

export const useCalendar = (sortCalendarChange) => {
  const dispatch = useDispatch();

  const handleChangeSort = useCallback(
    (s) => {
      dispatch(sortCalendarChange(s));
    },
    [dispatch, sortCalendarChange]
  );

  return {
    handleChangeSort,
  };
};
